module.exports = fox._r("images/foto-sample.png", __webpack_public_path__ + "_/_/_/common/frame/images/foto-sample.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/foto-sample.png
// module id = 130
// module chunks = 2